import { render, staticRenderFns } from "./IP_Trending.vue?vue&type=template&id=5e407df2&scoped=true&"
import script from "./IP_Trending.vue?vue&type=script&lang=js&"
export * from "./IP_Trending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e407df2",
  null
  
)

export default component.exports